import ReactPlayer from 'react-player'
import styled from 'styled-components'

export const MovieContainer = styled.div`
  height: 90vh;
  width: 100vw;
`

export const MovieElement = styled(ReactPlayer)`
  height: 100%;
  width: 100%;
`